const browserWindow = typeof window !== "undefined" && window

export default browserWindow
